<div class="text-center pt-2 xl:border-white transition-colors transition-duration-300" id="header" [ngClass]="{'scrolled shadow-3':scrollY > 0}" [style]="{width:mainWidth+'px'}">
	<div class="flex justify-content-between m-0 align-items-center">
		<div class="text-left">
			<img [ngStyle]="{maxHeight: api.pro && scrollY === 0 ? '110px' : !api.pro && scrollY === 0 ? '95px' : '80px'}" class="cursor-pointer transition-all transition-duration-300 max-w-full" id="logo" [routerLink]="['/accueil']" src="assets/logo-{{api.pro ? 'blanc' : 'slim-notext'}}.png"/>
		</div>
		<div class="relative">
			<div class="grid grid-nogutter">
				<div class="col-12 sm:block hidden" >
					<h1 *ngIf="api.pro" class="text-center mb-0 mt-0 text-primary transition-all transition-duration-300 md:text-4xl text-2xl">
						Mon Espace Pro
					</h1>
					<div *ngIf="api.user" class="text-primary	 text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis">{{api.user.Name}}</div>

					<h1 *ngIf="!api.pro" class="text-white sp-marker mb-0 transition-all transition-duration-300 md:text-4xl text-2xl">
						Blackrock Games
					</h1>
				</div>
				<div class="col-12 text-center p-0 flex justify-content-center z-2">
					<p-menubar [baseZIndex]="10" [model]="menu" styleClass="bg-transparent text-white m-auto relative"></p-menubar>
				</div>		
			</div>
		</div>
		<div class="flex flex-column justify-content-around -mt-2 align-items-center">
			<div class="absolute white-space-nowrap text-sm hidden transition-all transition-duration-300" style="top:5px;right:40px;" [ngClass]="{'sm:block':scrollY === 0}" *ngIf="api.pro">
				Frais de port offert à partir de <span class="font-bold">{{api.franco}} € </span><span class="text-xs vertical-align-text-top">net HT</span>
			</div> 
			<div class="w-full flex justify-content-end align-items-center pr-4 pt-0" *ngIf="api.user">
				<div class="flex-grow-1 text-left">
					<i pTooltip="Événements" tooltipPosition="top" class="px-2 fa-solid fa-calendar-days p-text-white cursor-pointer" style="font-size: 1.3rem"  [routerLink]='["/events"]' pBadge [value]="api.user.nb_events"></i>
				</div>
				<p-splitButton pTooltip="Mon compte" tooltipPosition="top" icon="pi pi-user" [model]="account" styleClass="flex-1 p-button-text p-button-secondary p-button-lg m-0"></p-splitButton>
				<i pTooltip="Mes favoris" tooltipPosition="top" class="px-2 pi pi-heart p-text-white cursor-pointer" style="font-size: 1.3rem"  [routerLink]='["/favoris"]' severity="info" ></i>
				<i pTooltip="Mon top jeux" tooltipPosition="top" [routerLink]="['/mon-top']" class="px-2 fa fa-ranking-star cursor-pointer "  style="font-size: 1.3rem"></i>
				<i class="px-2  pi pi-shopping-cart p-text-white cursor-pointer "  style="font-size: 1.3rem"  pBadge [value]="nbProds()" pStyleClass="#slideover-cart" enterClass="hidden" (click)="api.bodyOverflow('hidden')" enterActiveClass="fadeinright" leaveToClass="hidden" leaveActiveClass="fadeoutright" ></i>
			</div>
			<div class="text-center pr-2 lg:pr-4">
				<form>           
					<div class="p-inputgroup lg:w-18rem md:w-15rem  max-w-full m-auto">
						<p-autoComplete panelStyleClass="text-xs" appendTo="body" styleClass="w-full" field="name" name="query" [suggestions]="filteredGames" (completeMethod)="filter($event)" placeholder="{{'Recherche par nom' | translate}}" (onSelect)="searchForm.query = $event.name; search()" [ngModel]="searchForm.query"></p-autoComplete>
						<!-- <input type="text" pInputText placeholder="{{'Recherche par nom, réf. ou EAN ' | translate}}" [(ngModel)]="searchForm.query" name="query">    -->
						<button type="submit" pButton pRipple icon="pi pi-search" class="p-button" (click)="search()"></button>      
					</div>
				</form>
			</div>
		</div>
		<!-- <div class="text-left md:block hidden" *ngIf="!api.pro">
			<img class="cursor-pointer transition-all transition-duration-300 opacity-0" id="logo" [routerLink]="['/']" src="assets/logo-{{api.pro ? 'blanc' : 'slim-notext'}}.png"/>
		</div> -->
	</div>
	<div id="main-bg"></div>
</div>
<div [style]="{height:'110px'}" *ngIf="scrollY > 0 && api.inIframe"></div>
<app-cart></app-cart>